import {combineEpics} from 'web-app/util/redux-observable';

import keyWorkerEpics from './key-worker/epics';
import permissionListEpics from './permission-list/epics';
import healthEpics from './health/epics';
import sensitiveInfoEpics from './sensitive-information/epics';
import basicInfoEpics from './basic-info/epics';
import registrationEpics from './registration/epics';
import moveSettingEpics from './move-setting/epics';
import tagEpics from './tags/epics';
import holidayRSVPEpics from './holiday-rsvp/epics';
import leaveRegistrationEpics from './leave-registration/epics';
import activityEpics from './activity/epics';
import accidentIncidentReportEpics from './accident-indicent-reports/epics';
import contactsEpics from './contacts/epics';
import childModalEpics from './child-modal/epics';
import editBillPayersModalEpics from './plans-and-invoices/edit-bill-payers-modal/epics';

export default combineEpics(
    childModalEpics,
    contactsEpics,
    activityEpics,
    tagEpics,
    permissionListEpics,
    keyWorkerEpics,
    healthEpics,
    sensitiveInfoEpics,
    basicInfoEpics,
    registrationEpics,
    moveSettingEpics,
    holidayRSVPEpics,
    leaveRegistrationEpics,
    accidentIncidentReportEpics,
    editBillPayersModalEpics,
);
